import React from 'react'

const MobileProjectTitle = ({title}) => {
  return (
    <div className='w-full text-center font-display'>
      <br />
      <br />
        <h1 className='mx-6 mb-4 text-3xl font-display font-regular text-navy'>{title}</h1>
        <br />
    </div>
  )
}

export default MobileProjectTitle